import axios from 'axios';
import type { JoinOrganizationSuggestionResponseDto } from '@hotjar/webapp/domains/acquisition/join-organization-suggestion/dto';
import type { JoinOrganizationSuggestion } from '@hotjar/webapp/domains/acquisition/join-organization-suggestion/types';

/**
 * Check if there's an organization that the user might be interested in joining.

 * @return {object} Object include joining organization suggestion.
 */
export async function getJoinOrganizationSuggestion(): Promise<JoinOrganizationSuggestion> {
  const response: JoinOrganizationSuggestionResponseDto = await axios.get(
    '/api/v1/join_organization_suggestion',
  );
  return {
    suggestJoiningOrganization: response.data.suggest_joining_organization,
    name: response.data.name,
  };
}
